import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "environment"
}
const _hoisted_2 = { id: "nav" }
const _hoisted_3 = { id: "router-container" }
const _hoisted_4 = {
  id: "nav-controls",
  class: "top-button-container"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Brands")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = {
  id: "nav-cart",
  class: "top-button-container"
}
const _hoisted_10 = { id: "cart-box" }
const _hoisted_11 = { id: "cart-box-container" }
const _hoisted_12 = {
  id: "nav-info",
  class: "top-button-container"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("About Konyawoo")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.environment !== 'production')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.environment.toUpperCase()), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6,
          _createVNode(_component_router_link, { to: "/brands" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _hoisted_8,
          _createElementVNode("span", {
            id: "backButton",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, "Back")
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              id: "cart-box-router",
              to: "/cart"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, " Cart [ " + _toDisplayString(_ctx.cartCount) + " ] ", 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}